import React from 'react';

import { styled } from '../theme';
import { CommonComponentProps } from '../types/components';
import Text from './Text';

type Props = { align?: string };

const StyledText = styled(Text)<Props>(({ theme, align = 'left' }) => ({
    ...theme.typography.textStyles.body2,
    textAlign: align,
}));

export default React.forwardRef<HTMLSpanElement, CommonComponentProps<HTMLSpanElement> & Props>(
    (props, ref) => <StyledText ref={ref} {...props} />
);
